<template>
  <div class="com-mod-section-container">
    <h3 class="com-mod-section-header">
      Prices & Distributions
    </h3>
    <div class="row">
      <div class="col-md-12">
        <historical-prices />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <historical-distributions />
      </div>
    </div>
  </div>
</template>

<script>
import HistoricalPrices from '../Modules/HistoricalPrices';
import HistoricalDistributions from '../Modules/HistoricalDistributions';
export default {
	name: 'PricesAndDistributions',
	components: {
    HistoricalPrices,
    HistoricalDistributions
	}
};
</script>

